import dayjs from "dayjs";

import { formatAmount } from "@moonscape/shared";

import { TaxEvent } from "../types";

const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

/**
 * utility class that gives helpful functions to format a TaxEvent
 */
export class TaxEventItemClass {
  // class property types
  txn_id: string;
  ext_txn_id: string;
  disposal_type: string;
  asset: string;
  tax_year: string;
  proceeds: string;
  gain: string;
  cost: string;
  fees: string;
  quantity: string;
  datetime: string;
  coingeckoId: string;

  constructor(taxEventItem: TaxEvent) {
    const {
      txn_id,
      ext_txn_id,
      disposal_type,
      asset,
      tax_year,
      proceeds,
      gain,
      cost,
      fees,
      quantity,
      datetime,
      coingeckoId,
      assetDetails,
    } = taxEventItem;

    this.txn_id = txn_id;
    this.ext_txn_id = ext_txn_id;
    this.disposal_type = disposal_type;
    this.asset = asset;
    this.tax_year = tax_year;
    this.proceeds = proceeds;
    this.gain = gain;
    this.cost = cost;
    this.fees = fees;
    this.quantity = quantity;
    this.datetime = datetime;
    this.coingeckoId = coingeckoId;
    this.assetDetails = assetDetails;
  }

  getFormattedQuantity() {
    return formatAmount(this.quantity);
  }

  /** MMM D YYYY, HH:mm:ss */
  formattedTimestamp() {
    if (this.datetime) {
      const formatedTime = dayjs(this.datetime);

      if (formatedTime.isValid()) {
        return formatedTime.utc().format("MMM D YYYY, HH:mm:ss");
      }
    }
    return "";
  }
  /** HH:mm */
  formattedTime() {
    if (this.datetime) {
      const formatedTime = dayjs(this.datetime);

      if (formatedTime.isValid()) {
        return formatedTime.utc().format("HH:mm");
      }
    }
    return "";
  }

  truncate(input, nchars) {
    if (input?.length > nchars) {
      return input.substring(0, nchars) + "...";
    }
    return input;
  }
}
